import es from "./es";
import en from "./en";
import de from "./de";
import it from "./it";
import nl from "./nl";
import fr from "./fr";
import ro from "./ro";
import ru from "./ru";
import ar from "./ar";
import zh from "./zh";
import { withPro } from "./pro";
import NUVLI from "./nuvli";

const HOME = Object.fromEntries(Object.entries({ es, en, de, it, nl, fr, ro, ru, ar, zh }).map(([k, v]) => [k, { ...withPro(k, v), nuvli: NUVLI[k] || NUVLI.es }]));
export default HOME;
